import { Injectable, signal } from "@angular/core";
import { ItemDataService } from "./item-data.service";
import { CosmeticPresetsService } from "./cosmetic-presets.service";
import { Color } from "../models/enums";
import { LOCAL_STORAGE_KEY_RECENTLY_USED_COLORS } from "../const";
import { SettingsService } from "./settings.service";

const MAX_RECENTLY_USED_COLORS = 6;

@Injectable({
  providedIn: 'root'
})
export class CosmeticsService {
  itemColors!: string[];
  extraColors!: string[];
  recentlyUsedColors!: string[];
  presetColors = signal<string[]>([]);

  constructor(private itemDataService: ItemDataService, private settings: SettingsService) {
    this.itemColors = Object.values(this.itemDataService.getItemColors());
    this.extraColors = [
      CosmeticPresetsService.tieredTextColors[Color.Purple],
      CosmeticPresetsService.tieredTextColors[Color.Red],
      CosmeticPresetsService.tieredTextColors[Color.Orange],
      CosmeticPresetsService.tieredTextColors[Color.Yellow],
      CosmeticPresetsService.textColor,
      CosmeticPresetsService.bgColor,
    ];
    this.recentlyUsedColors = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_RECENTLY_USED_COLORS) || '[]');
    this.buildPresetColors();
  }

  public buildPresetColors() {
    this.presetColors.set(this.itemColors);
    if (this.settings.addMoreColorPresets()) {
      this.presetColors.set(this.presetColors().concat(
        ...this.extraColors,
        ...this.recentlyUsedColors,
      ));
    }
  }

  addRecentlyUsedColor(color: string) {
    if (this.itemColors.includes(color)) return;
    if (this.extraColors.includes(color)) return;

    if (this.recentlyUsedColors.includes(color)) {
      this.recentlyUsedColors.splice(this.recentlyUsedColors.indexOf(color), 1);
    }
    this.recentlyUsedColors.unshift(color);
    this.recentlyUsedColors.splice(MAX_RECENTLY_USED_COLORS);
    localStorage.setItem(LOCAL_STORAGE_KEY_RECENTLY_USED_COLORS, JSON.stringify(this.recentlyUsedColors));

    if (this.settings.addMoreColorPresets()) {
      this.buildPresetColors();
    }
  }
}
